<template>
    <div>
        <div>
            <div class="page__head container">
                <div class="page__head-inner block">
                    <h1 class="page__title page__title--icon">
                        <div class="fab-icon">
                            <i class="icon icon--dialog"></i>
                        </div>
                        Единый Портал Потребителей СГК
                    </h1>
                    <div class="register-form b-form b-form--lg">
                        <div class="page__descr page__descr--full">
                            <span>Добро пожаловать в обновлённый Единый Портал Потребителей! Для продолжения работы ознакомьтесь и примите «Правила пользования системой», «Порядок и условия оплаты, зачисления и возврата денежных средств»</span>
                        </div>
                    </div>
                </div>
            </div>


            <div class="page__main container">
                <div class="page__index block">
                    <form>
                        <div class="b-form__footer b-form__footer--reqister">
                            <div class="register-submit register-submit--offset-right">
                                <div class="register-submit__col register-submit__col--offset-right">
                                    <div class="register-submit__check">
                                        <div class="fast-pay-submit__line">
                                            <label class="cb-input cb-input--right">
                                                <input class="cb-input__checkbox" type="checkbox" v-model="isAgreedRules">
                                                <span class="cb-input__check"></span>
                                                <span class="cb-input__label">Я принимаю <a href="/site/useragreement" target="_blank" class="link link--present">«Правила пользования системой»</a></span>
                                            </label>
                                        </div>
                                        <div class="fast-pay-submit__line">
                                            <label class="cb-input cb-input--right">
                                                <input class="cb-input__checkbox" type="checkbox" v-model="isAgreedPaymentRules">
                                                <span class="cb-input__check"></span>
                                                <span class="cb-input__label">
                                                    С порядком и условиями оплаты, <br>
                                                    <a href="/site/useragreement#:~:text=5,-.%20Порядок" target="_blank" class="link link--underline"><span class="link__text">зачисления</span></a> и
                                                    <a href="/site/useragreement#:~:text=5,-.%20Порядок" target="_blank" class="link link--underline"><span class="link__text">возврата</span></a> денежных средств согласен.
                                                </span>
                                            </label>
                                        </div>
                                    </div>

                                    <a class="register-submit__button button button--th-main"
                                       :class="(!isAgreedRules || !isAgreedPaymentRules)? 'is-disable' : ''"
                                       v-on:click="UpdateAgreement">
                                        <span class="button__text">Продолжить</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>


    </div>

</template>
<script>

    const { required, minLength, maxLength, sameAs } = window.validators
    const { validationMixin } = window.vuelidate

    import MaskedInput from 'vue-masked-input';

    import { formatMobileNumberToDigits } from '../../../../wwwroot/app/epp.utils';

    export default {
        mixins: [validationMixin],
        components: {
            'masked-input': MaskedInput,
        },
        props: {
            //Флаги отображения
            //// номер случая
            casenumber: 0
        },
        data: function () {
            return {
                isServerVerify: false,
                isAgreedRules: false,
                isAgreedPaymentRules: false,
                login: '',
                password: '',
                confirmPassword: '',
                phone: '',
                email: '',
                firstName: '',
                middleName: '',
                phoneMask: {
                    pattern: '\+7-w11-111-1111',
                    formatCharacters: {
                        'w': {
                            validate: function (char) { return /\9/.test(char) },
                            transform: function (char) { return char.toLowerCase() }
                        }
                    }
                },
                isValidateErrors: false,
                serverMessage: '',
                serverResponse: [],

                /// верификация телефона
                phoneVerifyError: '',
                isPhoneVerified: 0,
                phoneCode: '',
                /// верификация email
                emailVerifyError: '',
                isEmailVerified: 0,
                emailCode: '',
                //ошибка регистрации
                registerError: '',
                //Флаги отображения
                //// номер случая

                //// на регистрацию
                onRegisterMode: 0,
                //// на приём соглашений
                agreementMode: 0
            }
        },
        created() {
        },
        computed: {
            passwordTypeText: function () {
                return this.$v.password.$invalid && this.password != '' ? 'Пароль не соответствует требованиям, выделенным красным цветом выше' : '';
            },
            loginTypeText: function () {
                return !this.$v.login.loginType && this.login != '' ? 'Логин может содержать буквы [A-Z][a-z][А-Я][а-я] цифры [0-9] и спецсимволы [!@#$%^&*()_+.]' : ' ';
            },
            confirmPasswordTypeText: function () {
                return this.$v.confirmPassword.$invalid && this.password != '' ? 'Пароли должны совпадать' : '';
            },
            emailTypeText: function () {
                if (this.$v.email.$invalid && this.email != '') {
                    this.emailVerifyError = '';
                    return 'Недопустимые символы в E-mail адресе';
                }
                return '';
            },
            phoneTypeText: function () {
                if (this.$v.phoneForApi.$invalid) {
                    this.phoneVerifyError = '';
                    return 'Номер должен содержать 10 цифр';
                }
                return '';
            },
            serverResponseText: function () {
                return this.serverMessage != '' ? this.serverMessage : 'Указанные данные можно изменить в разделе "Настройки личного кабинета" после успешной регистрации';
            },
            phoneForApi: function () {
                return formatMobileNumberToDigits(this.phone) ? formatMobileNumberToDigits(this.phone) : null;
            }
        },
        watch: {
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = '';
                }
            },
            serverResponse: function (serverResponse) {
                if (serverResponse.isSuccess) {
                    this.isValidateErrors = false;
                    this.isServerVerify = true;
                    //this.$emit('update', this.newLogin);
                    //this.serverMessage = ['Логин успешно изменён, укажите его при следующем входе'];
                } else {
                    this.isValidateErrors = true;
                    this.isServerVerify = false;
                    this.serverMessage = serverResponse.message[0];
                }
            }
        },
        validations: {
            login: {
                required: false,
                //required: required,
                maxLength: maxLength(30),
                loginType: function (value) {
                    return true;
                    //return value.match('^[A-Za-zА-Яа-я0-9!@#$%^&*()_+.]+$') ? true : false;
                }
            },
            password: {
                required: required,
                minLength: minLength(8),
                mustOneMoreUpperCase: function (value) {
                    return value.match('[A-ZА-Я]+') ? true : false;
                },
                mustOneMoreLowerCase: function (value) {
                    return value.match('[a-zа-я]+') ? true : false;
                },
                mustOneMoreSpecialCharacter: function (value) {
                    return value.match('[!@#$%^&*()_+.]+') ? true : false;
                },
                mustOneMoreDigit: function (value) {
                    return value.match('[0-9]+') ? true : false;
                }
            },
            confirmPassword: {
                sameAsconfirmPassword: sameAs('password')
            },
            phoneForApi: {
                required: required,
                length: function (value) {
                    return this.phone != '' && this.phoneForApi == null ? false : true;
                }
            },
            email: {
                required: false,
                emailType: function (value) {
                    if (value != '') {
                        return value.match('\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*') ? true : false;
                    }
                    return true;
                }
            }
        },
        methods: {
            test: function () {
                console.log(' email=', this.email, ' isEmailVerified=', this.isEmailVerified, ' isAgreedPaymentRules=', this.isAgreedPaymentRules);
                console.log(' this.email =="" =', this.email == '', ' isEmailVerified<1 =', this.isEmailVerified < 1, ' t =', (this.email == '' && this.isEmailVerified < 1));
                //
                //(this.$v.$invalid || isPhoneVerified != 1 || !isAgreedRules || !isAgreedPaymentRules || !(this.email == '' && this.isEmailVerified < 1))
                console.log(' this.$v.$invalid =', this.$v.$invalid);
                console.log(' isPhoneVerified != 1 =', this.isPhoneVerified != 1);
                console.log(' !isAgreedRules =', !this.isAgreedRules);
                console.log(' !isAgreedPaymentRules =', !this.isAgreedPaymentRules);
                console.log(' !(this.email == "" && this.isEmailVerified < 1) =', !(this.email == '' && this.isEmailVerified < 1));
                console.log(' !(email != "" && isEmailVerified < 1) =', !(this.email != '' && this.isEmailVerified < 1));



            },
            verifyPhoneCode: async function () {
                var self = this;
                this.isValidateErrors = false;
                return await axios.post('/Register/VerifyCode', {
                    Phone: self.phoneForApi,
                    VerificationCode: self.phoneCode
                })
                    .then(function (response) {
                        console.log(response);
                        if (response.data.isSuccess) {
                            self.phoneVerifyError = '';
                        }
                        else {
                            self.phoneVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        return false;
                    });
            },
            verifyEmailCode: async function () {
                console.log(" verifyEmailCode start");
                var self = this;
                this.isValidateErrors = false;

                return await axios.post('/Register/VerifyCode', {
                    Login: formId,
                    Email: self.email,
                    VerificationCode: self.emailCode
                })
                    .then(function (response) {
                        console.log(response);
                        if (response.data.isSuccess) {
                            self.emailVerifyError = '';
                        }
                        else {
                            self.emailVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        return false;
                    });
            },
            verifyEmailCheckCode: async function (event) {

                event.stopPropagation();
                this.isEmailVerified = 0;
                console.log("verifyEmailCheckCode 1 ");
                console.log("this.isEmailVerified = ", this.isEmailVerified);

                if (this.emailCode == '') {
                    return;
                }

                const container = $('.js-timer-container.email');
                const poisonCode = container.find('.js-poison-code')
                const poisonCodeAgain = container.find('.js-poison-code-again');
                const connectEdm = container.find('.js-connect-edm');
                const inputCode = container.find('.js-input-code');
                const timer = container.find('.js-timer');

                if (await this.verifyEmailCode()) {
                    console.log("Успех верификации email");
                    this.isEmailVerified = 1;
                    inputCode.hide();
                }
                else {
                    console.log("Ошибка верификации email");
                    //$("#phone").prop("disabled", false);
                    this.isEmailVerified = -1;
                }

                console.log("this.isEmailVerified = ", this.isEmailVerified);
            },

            verifyPhoneCheckCode: async function (event) {

                event.stopPropagation();
                this.isPhoneVerified = 0;
                console.log("verifyPhoneCheckCode 1 ");
                console.log("this.isPhoneVerified = ", this.isPhoneVerified);

                if (this.phoneCode == '') {
                    return;
                }

                const container = $('.js-timer-container.phone');
                const poisonCode = container.find('.js-poison-code')
                const poisonCodeAgain = container.find('.js-poison-code-again');
                const connectEdm = container.find('.js-connect-edm');
                const inputCode = container.find('.js-input-code');
                const timer = container.find('.js-timer');

                var v = await this.verifyPhoneCode();
                console.log("Успех верификации телефона ", v);

                if (v) {
                    console.log("Успех верификации телефона");
                    this.isPhoneVerified = 1;
                    inputCode.hide();
                }
                else {
                    console.log("Ошибка верификации телефона");
                    //$("#phone").prop("disabled", false);
                    this.isPhoneVerified = -1;


                    //poisonCode.hide();
                    //poisonCodeAgain.hide();

                }

                console.log("this.isPhoneVerified = ", this.isPhoneVerified);

            },
            verifyPhoneStart: function (event) {
                event.stopPropagation();

                if (this.phoneForApi == null) {
                    return;
                }

                const self = this;

                console.log("verifyPhoneStart");
                $("#phone").attr('disabled', 'disabled');
                self.phoneVerifyError = '';
                self.isPhoneVerified = 0;
                self.phoneCode = '';

                console.info(self.phoneForApi);
                axios.post('/Register/SendRequestPhoneVerify/' + self.phoneForApi)
                    .then(function (response) {
                        console.info('PhoneVerify ', response);
                        if (response.data.isSuccess) {
                            const container = $('.js-timer-container.phone');
                            const poisonCode = container.find('.js-poison-code')
                            const poisonCodeAgain = container.find('.js-poison-code-again');
                            const connectEdm = container.find('.js-connect-edm');
                            const inputCode = container.find('.js-input-code');
                            const timer = container.find('.js-timer')[0];
                            if (poisonCode.length > 0) {
                                poisonCode.hide();
                                poisonCodeAgain.hide();
                                if (connectEdm) connectEdm.show();
                                if (inputCode) inputCode.show();
                                playTimer(timer);
                                self.checkTimer(poisonCodeAgain, self.verifyPhoneAgain);
                            };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.phoneVerifyError = response.data.message.join('');
                            $("#phone").prop('disabled', '');
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
                        $("#phone").prop('disabled', '');
                    });
            },
            verifyPhoneAgain() {
                $("#phone").prop('disabled', '');
            },
            verifyEmailStart: function (event) {
                if (this.email == '') {
                    return;
                }

                const self = this;

                console.log("verifyEmailStart");
                $("#email").attr('disabled', 'disabled');
                self.emailVerifyError = '';
                self.isEmailVerified = 0;
                self.emailCode = '';

                axios.post('/Register/SendRequestEmailVerify/' + formId + '/' + self.email)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            const container = $('.js-timer-container.email');
                            const poisonCode = container.find('.js-poison-code')
                            const poisonCodeAgain = container.find('.js-poison-code-again');
                            const connectEdm = container.find('.js-connect-edm');
                            const inputCode = container.find('.js-input-code');
                            const timer = container.find('.js-timer')[0];
                            if (poisonCode.length > 0) {

                                poisonCode.hide();
                                poisonCodeAgain.hide();
                                if (connectEdm) connectEdm.show();
                                if (inputCode) inputCode.show();
                                playTimer(timer);
                                self.checkTimer(poisonCodeAgain, self.verifyEmailAgain);
                            };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.emailVerifyError = response.data.message.join('');
                            $("#email").prop('disabled', '');
                        }

                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация email невозможна, попробуйте позже';
                        $("#email").prop('disabled', '');
                    });

                event.stopPropagation();
            },
            verifyEmailAgain() {
                $("#email").prop('disabled', '');
            },

            checkTimer(timer, fn) {
                var timerInterval = null;
                timerInterval = setInterval(function () {
                    if (timer.css('display') != 'none') {
                        fn();
                        clearInterval(timerInterval);
                    }
                }, 2000);
            },

            IsSiriusAccountUnionComplete: function () {
				var self = this;

				axios.post('/Account/IsSiriusAccountUnionComplete')
					.then(function (response) {
                        console.log(response);
                        window.location.href = response.data;
					})
					.catch(function (error) {
						console.log(error);
					});
            },

            UpdateAgreement: function () {
                var self = this;
                this.isValidateErrors = false;

                axios.post('/Account/UpdateAgreement', {
                    IsAgreeRules: self.isAgreedRules
                })
                    .then(function (response) {
                        console.info(response);
                        if (response.data.isSuccess) {
                            self.IsSiriusAccountUnionComplete();
                           // window.location.href = "/register/RegisterFork";
                        }
                        self.registerError = response.data.errors.join("\n");
                        self.isPhoneVerified = 0;
                        self.isEmailVerified = 0;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.serverMessage = ['Регистрация невозможна, попробуйте позже']
                    });
            },
        }
    }
</script>
<style>
    .error-block {
        display: block;
        color: #ef3e55;
    }

    .validated-block {
        display: block;
        color: #0078a8;
        opacity: 1;
    }

    .show {
        display: block;
    }

    .hide {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// Scripts/app/union/components/Agreement.vue